export default __webpack_public_path__ + "img/venta-800.6bda44d0.jpg";